(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilates-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function iniciar(seccion) {
      if (seccion.dataset.pilListo) return;
      seccion.dataset.pilListo = '1';

      var pista = seccion.querySelector('[data-pilates-pista]');
      var prev = seccion.querySelector('[data-pilates-prev]');
      var next = seccion.querySelector('[data-pilates-next]');
      var puntos = seccion.querySelectorAll('[data-pilates-puntos] span');
      if (!pista) return;

      var tarjetas = pista.children;
      var intervalo = parseInt(seccion.dataset.intervalo, 10) || 5000;
      var timer = null;
      var visible = false;
      var hover = false;

      function paso() {
        var t = tarjetas[0];
        if (!t) return 0;
        var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
        return t.getBoundingClientRect().width + gap;
      }

      function indice() {
        var p = paso();
        return p ? Math.round(pista.scrollLeft / p) : 0;
      }

      function marcar() {
        var i = indice();
        for (var k = 0; k < puntos.length; k++) {
          puntos[k].classList.toggle('activo', k === i);
        }
      }

      function irA(i) {
        var total = tarjetas.length;
        if (i >= total) i = 0;
        if (i < 0) i = total - 1;
        pista.scrollTo({ left: i * paso(), behavior: reducido ? 'auto' : 'smooth' });
      }

      function avanzar() {
        // Al final vuelve al principio: el loop es infinito.
        var fin = pista.scrollWidth - pista.clientWidth - 4;
        if (pista.scrollLeft >= fin) irA(0);
        else irA(indice() + 1);
      }

      function arrancar() {
        detener();
        if (reducido || !visible || hover || document.hidden) return;
        timer = setInterval(avanzar, intervalo);
      }

      function detener() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      // El temporizador parte cuando la sección entra en pantalla, no al cargar.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          visible = entradas[0].isIntersecting;
          arrancar();
        }, { threshold: 0.25 }).observe(seccion);
      } else {
        visible = true;
        arrancar();
      }

      pista.addEventListener('scroll', marcar, { passive: true });
      pista.addEventListener('mouseenter', function () { hover = true; detener(); });
      pista.addEventListener('mouseleave', function () { hover = false; arrancar(); });
      document.addEventListener('visibilitychange', arrancar);

      // Cualquier interacción manual reinicia la cuenta desde cero.
      function manual(fn) {
        return function (e) {
          if (e) e.preventDefault();
          fn();
          arrancar();
        };
      }

      if (prev) prev.addEventListener('click', manual(function () { irA(indice() - 1); }));
      if (next) next.addEventListener('click', manual(function () { avanzar(); }));

      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') manual(function () { avanzar(); })(e);
        if (e.key === 'ArrowLeft') manual(function () { irA(indice() - 1); })(e);
      });

      pista.addEventListener('touchstart', function () { detener(); }, { passive: true });
      pista.addEventListener('touchend', function () { arrancar(); }, { passive: true });

      marcar();
    }

    function boot() {
      document.querySelectorAll('[data-pilates-carrusel]').forEach(iniciar);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
